export type Etags = Record<string, string>;

const etags: Etags = {};

export const setEtag = (key: string, value: string) => {
    etags[key] = value;
};

export const getEtag = (key: string) => {
    return etags[key];
};

export const unsetEtag = (key: string) => {
    delete etags[key];
};
